/**
 *  lib/storefront/wick_guide/wick.js
 */

import BaseWick from './base-wick.js'
import NullWick from './null-wick.js'

class Wick extends BaseWick {
  constructor(...args) {
    let name;
    let url;
    if (args[0] instanceof BaseWick) {
      const givenWick = args[0];
      name = givenWick.name;
      url = givenWick.url;
    } else {
      name = args[0];
      url = args[1];
    }
    super(name, url);
    this.secondaryWick = new NullWick();
  }

  get secondRow() {
    return this.secondaryWick;
  }
}

export default Wick;
